<template>
    <div class="workout-stats-conatiner">
        <div>
            <label class="title">Workout Statistics</label>
        </div>
        <div class="workout-details" style="padding-top: 0;padding-left: 1rem;">
            <div class="row" style="width: 100%;">
                <div class="stat col" style="width: 50%;padding: 0;">
                    <div class="row">
                        <div class="label">Total Steps</div>
                        <div class="col">
                            <span class="value">{{ data.workout_record_step }}</span>
                        </div>
                    </div>
                </div>
                <div class="stat col" style="width: 50%;padding: 0;">
                    <div class="row">
                        <div class="label">Avg Cadence</div>
                        <div class="col">
                            <span class="value">{{ data.avg_cadence }} steps/min</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" style="width: 100%;">
            <div class="stat col" style="width: 50%;padding: 0;">
                <div class="row">
                    <span class="label">VO2Max</span>
                    <div class="col">
                        <span class="value">{{data.workout_max_met > 0 ? 
                        Math.round((data.workout_max_met * 3.5)/65536) : 0}} ml/kg/min</span>
                    </div>
                </div>
            </div>
            <div class="stat col" style="width: 50%;padding: 0;">
                <div class="row">
                    <span class="label">Avg Pace</span>
                    <div class="col">
                        <span class="value">{{ getAvgPace() }}</span>
                    </div>
                </div>
            </div>
            </div>
            <div class="row" style="width: 100%;">
            <div class="stat col" style="width: 50%;padding: 0;">
                <div class="row">
                    <span class="label">Fastest Pace</span>
                    <div class="col">
                        <span class="value">{{ getFastestPace() }}</span>
                    </div>
                </div>
            </div>
            <div class="stat col" style="width: 50%;padding: 0;">
            </div>
            </div>
        </div>
    </div>    
</template>

<script>
  import Utils from "@/helpers/utils";

  export default {
    name: 'WorkoutStatistics',
    mounted() {
    },
    props: {
    data: {
        type: Object,
        required: true,
      }
    },
    methods: {
        getAvgPace() {
          let avg_pace = Utils.formatPace(this.data.avg_pace);
          return `${avg_pace} /km`;
        },
        getFastestPace() {
          let fastest_pace = Utils.formatPace(this.data.fastest_pace);
          return `${fastest_pace} /km`;
        }
    },
  };
</script>

<style lang="scss" scoped>
  .workout-stats-conatiner {
    background-color: #1C1D1F !important;
    color: #ffffff;
    border-radius: 0.5rem;
    padding: 1rem;
    height: 100%;
  }
  .container-header {
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .date {
    font-size: 14px;
    line-height: 1.2;
    padding-top: 1rem;
  }
  .workout-details {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .stat {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
  }
  .label {
    color: #b0bec5;
    font-size: 0.75rem;
    font-weight: 600;
  }
  .value {
    color: #ffffff;
    font-weight: bold;
    font-size: 0.85rem;
  }
  .activity-date {
    font-size: 1rem;
    font-weight: 500;
    padding-left: 3rem;
  }
  .activity-time {
    font-size: 0.9rem;
    color: #909ea0;
    font-weight: 500;
    padding-left: 1.8rem;
  }
  .title {
    font-size: 1rem;
    font-weight: bold;
  }
</style>